import {DownloadedFile} from "../../../utils/fileTransferUtils";
import {exportOpeningHours, importOpeningHours} from "./bulkUpdateApi";

export interface BulkUpdateDefinition {
    key: string
    title: string
    description: string
    iconSrc: string
    hints: string[]
    exportFile: () => Promise<DownloadedFile>
    importFile: (file: File) => Promise<string>
}

export const BULK_UPDATES: BulkUpdateDefinition[] = [
    {
        key: "location-working-hours",
        title: "Location working hours",
        description: "Opening and aftersales hours of every location, one row per location and schedule.",
        iconSrc: "/calendar.svg",
        hints: [
            "Write each day as opening and closing time, like 09:00-17:30, or Closed.",
            "Leave a day empty to keep its current hours. Rows you do not need can be deleted.",
            "Keep the downloaded file: uploading it again puts those hours back.",
            "If any row is invalid, nothing is saved and every problem is listed."
        ],
        exportFile: exportOpeningHours,
        importFile: async file => {
            const result = await importOpeningHours(file);
            return `Updated ${result.schedulesUpdated} schedule(s). ${result.schedulesUnchanged} already matched the file.`;
        }
    }
];

export const findBulkUpdate = (key?: string): BulkUpdateDefinition | undefined =>
    BULK_UPDATES.find(definition => definition.key === key);
